import React from 'react';
import { Switch, Redirect, Route } from 'react-router-dom';

import TechnicianPatientPage from 'containers/TechnicianPatientPage';
import CardiovascularReports from 'components/CardiovascularReports';
import PatientList from 'containers/PatientList';
import ReportsHistory from 'containers/ReportsHistory/OtherRoles';
import ReportsList from 'containers/ReportsList';
import Profile from 'containers/TechnicianProfile';

const TechnicianRoutes = () => (
  <Switch>
    <Route path="/patient-list" component={PatientList} />
    <Route path="/reports" component={ReportsList} />
    <Route path="/profile" component={Profile} />
    <Route exact path="/patient/:id/reports" component={ReportsHistory} />
    <Route exact path="/patient/:id/cardiovascular-reports" component={CardiovascularReports} />
    <Route path="/patient/:id" component={TechnicianPatientPage} />
    <Redirect to="/patient-list" />
  </Switch>
);

export default TechnicianRoutes;
